import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetDashboardDateState = atomFamily({
  key: "myTimesheetDashboardDateState",
  default: new Date(),
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetDashboardDateState;
